<template>
   <div class="flex items-center gap-5">
      <NuxtLink
         class="__clickable shrink-0"
         to="https://play.google.com/store/apps/details?id=com.suedtirolfishing.mobile"
      >
         <div class="flex items-center gap-2">
            <Icon name="google-play" class="size-6" />
            <div class="flex flex-col">
               <p class="p-s">{{ $t('common.download-on') }}</p>
               <p class="h-m">Google Play</p>
            </div>
         </div>
      </NuxtLink>

      <NuxtLink class="__clickable shrink-0" to="https://apps.apple.com/it/app/id6745882710">
         <div class="flex items-center gap-2">
            <Icon
               name="apple"
               class="size-6"
               :class="{
                  'text-white': !appleBlack,
                  'text-black': appleBlack,
               }"
            />
            <div class="flex flex-col">
               <p class="p-s">{{ $t('common.download-on') }}</p>
               <p class="h-m">App Store</p>
            </div>
         </div>
      </NuxtLink>
   </div>
</template>

<script lang="ts" setup>
type Props = {
   appleBlack?: boolean
}
const props = withDefaults(defineProps<Props>(), {})
</script>
